import {
  useGetLocationByKey,
  useListCompanyContacts,
  useListCompanyPhones,
} from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import { BranchForm } from '../BranchForm/index';
import { useParams } from 'react-router-dom';
import {
  GetLocationByKey,
  GetCompanyContactByKey,
  GetCompanyPhoneByKey,
} from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types';
import { Loading } from '@trufla-technology/trumarket-react-design-system';
export type SearchObject = {
  searchValue: string;
};
interface IParams {
  key: string;
}
export const EditBranch = () => {
  const { key } = useParams<IParams>();
  const { data, loading } = useGetLocationByKey(key);
  const { data: CompanyContacts, loading: loadingCompanyContacts } =
    useListCompanyContacts({
      filter: {
        locationKeys: [key],
      },
    });
  const { data: CompanyPhones, loading: loadingCompanyPhones } =
    useListCompanyPhones({
      filter: {
        locationKeys: [key],
      },
    });
  return (
    <div className="">
      {loading && <Loading />}
      {!loading && !loadingCompanyContacts && !loadingCompanyPhones && data && (
        <BranchForm
          mode="edit"
          branchKey={key}
          initialData={data as GetLocationByKey}
          contactsData={CompanyContacts as GetCompanyContactByKey[]}
          phonesData={CompanyPhones as GetCompanyPhoneByKey[]}
        />
      )}
    </div>
  );
};
